/**
 * Routes privées / transactionnelles : noindex pour préserver le crawl budget.
 * Les patterns sont testés sur pathname (sans query string).
 */
export const NOINDEX_PATH_PATTERNS: RegExp[] = [
  /^\/recherche\/?$/,
  /^\/login\/?$/,
  /^\/signup\/?$/,
  /^\/inscription\/?$/,
  /^\/password-forgotten\/?$/,
  /^\/reset-password\/?$/,
  /^\/admin-handoff\/?$/,
  /^\/profile\/?$/,
  /^\/animal\/?$/,
  /^\/animals\//,
  /^\/messaging\/?$/,
  /^\/favorites\/?$/,
  /^\/reservations\/?$/,
  /^\/mes-suivis\/?$/,
  /^\/compte-rendus\/?$/,
  /^\/quotes\/?$/,
  /^\/mes-forfaits\/?$/,
  /^\/mes-abonnements\/?$/,
  /^\/credits\/?$/,
  /^\/mes-cadeaux\/?$/,
  /^\/checkout\/?$/,
  /^\/validated-checkout\/?$/,
  /^\/cancel-checkout\/?$/,
  /^\/thank-you\/?$/,
  /^\/booking-confirmation\/?$/,
  /^\/confirm-booking\//,
  /^\/decline-booking\//,
  /^\/auth\//,
  /^\/event-payment-success\/?$/,
  /^\/forfait\//,
  /^\/forfait-ready\/?$/,
  /^\/forfait-purchase-cgv\/?$/,
  /^\/credits-purchase/,
  /^\/boarding-success\/?$/,
  /^\/club-subscription-success\/?$/,
  /^\/cgv-accept\//,
  /^\/documents\/view\//,
  /^\/carnet\//,
  /^\/public\/quote\//,
  /^\/pro\/[^/]+\/book\/?$/,
  /^\/pro\/[^/]+\/forfait\//,
  /^\/pro\/[^/]+\/abonnement\//,
  /^\/pro\/\d+\/pin-management\/?$/,
  /^\/pro-old\//,
  /^\/dev\//,
  /^\/embed\//,
  /^\/event\//,
  /^\/association\//,
];

export function pathnameShouldNoIndex(pathname: string): boolean {
  return NOINDEX_PATH_PATTERNS.some(pattern => pattern.test(pathname));
}
